export default "__VITE_ASSET__e029654d__"